<template>
  <a v-if="!isButtonLink" class="ELYXModalTextLink" :href="href" target="_blank">
    <slot></slot>
  </a>
  <span v-else class="ELYXModalTextLink" @click="toggle" target="_blank">
    <slot></slot>
  </span>
</template>

<script>
export default {
  props: {
    href: {
      type: String,
      default: "#",
    },
    isButtonLink: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggle() {
      this.$emit("click");
    },
  },
};
</script>

<style>
.ELYXModalTextLink {
  margin-top: calc(10px / var(--heightResoRatio));
  width: calc(365px / var(--widthResoRatio));
  font-size: calc(14px / var(--widthResoRatio)) !important;
  line-height: calc(22px / var(--heightResoRatio));
  text-align: center;
  margin-bottom: 0px;
  font-weight: 600;
  color: #304976;
  text-decoration: underline;
  outline: 0;
  transition: color 0.2s linear;
  cursor: pointer;
}
.ELYXModalTextLink:hover {
  color: #4a6eb3;
}
</style>
